import { render, staticRenderFns } from "./ClientReviews.vue?vue&type=template&id=5e99042c&"
import script from "./ClientReviews.vue?vue&type=script&lang=js&"
export * from "./ClientReviews.vue?vue&type=script&lang=js&"
import style0 from "./ClientReviews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports